import { gateway } from "../../../gateway";
import { AppState } from "../types/appIntegration.types";

export const getAppIntegrationStatus = async (appId: string): Promise<AppState> => {
  const response = await gateway.get<{ data: { status: AppState } }>(`/app-integrations/${appId}/status`);
  return response.data?.data?.status ?? "not_installed";
};
